module.exports = __webpack_public_path__ + "static/media/14.114007cc.gif";